import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { BusinessResponseDTO } from 'src/app/shared/models/dtos/register-form/business-response-dto/business-response-dto';
import { maxNameLength } from 'src/app/utils/text-max-lenght';

@Component({
  selector: 'app-business-change',
  templateUrl: './business-change.component.html',
  styleUrls: ['./business-change.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
/**
 * Business change molecule
 */
export class BusinessChangeComponent implements OnInit {
  @Input() currentBusiness!: BusinessResponseDTO;
  @Input() newBusiness!: BusinessResponseDTO;
  maxNameLength = {
    currentBusiness: false,
    newBusiness: false,
  };

  /**
   * on init
   */
  ngOnInit(): void {
    this.maxNameLength = {
      currentBusiness: maxNameLength(this.currentBusiness.businessName!, 18),
      newBusiness: maxNameLength(this.newBusiness.businessName!, 18),
    };
  }
}
